export const SAVE_CUSTOM_FILTERS = 'SAVE_CUSTOM_FILTERS'
export const CUSTOM_FILTERS_REQ = 'CUSTOM_FILTERS_REQ'
export const UPDATE_CUSTOM_FILTERS = 'UPDATE_CUSTOM_FILTERS'
export const DELETE_CUSTOM_FILTERS = 'DELETE_CUSTOM_FILTERS'



// WEBPACK FOOTER //
// ./src/store/modules/custom-filters/custom-filters.type.js